import React, {Suspense} from "react";
import {useSelector} from "react-redux";
import Loader from "../../components/loader/Loader";
import {
  ROLE_ROOT,
  ROLE_ADMIN,
  ROLE_MODERATOR,
  ROLE_JURY,
  ROLE_MANAGER,
  ROLE_PARTICIPANT
} from "../../data/Role";

const RootRouter = React.lazy(() => import('../roles/root/content/RootRouter'));
const AdminRouter = React.lazy(() => import('../roles/admin/content/AdminRouter'));
const ModeratorRouter = React.lazy(() => import('../roles/moderator/content/ModeratorRouter'));
const JuryRouter = React.lazy(() => import('../roles/jury/content/JuryRouter'));
const ManagerRouter = React.lazy(() => import('../roles/manager/content/ManagerRouter'));
const ParticipantRouter = React.lazy(() => import('../roles/participant/content/ParticipantRouter'));
const GuestRouter = React.lazy(() => import('../roles/guest/content/GuestRouter'));

export default function Content() {
  const user = useSelector(state => state.user);

  return (
    <div className={user.isGuest ? 'content-guest' : 'content-auth'}>
      <Suspense fallback={<Loader/>}>
        {renderRouter()}
      </Suspense>
    </div>
  );

  function renderRouter() {
    if (null === user.profile) {
      return <GuestRouter/>;
    }

    const roleName = user.profile.role.name;

    if (ROLE_ROOT === roleName) {
      return <RootRouter/>;
    } else if (ROLE_ADMIN === roleName) {
      return <AdminRouter/>;
    } else if (ROLE_MODERATOR === roleName) {
      return <ModeratorRouter/>;
    } else if (ROLE_JURY === roleName) {
      return <JuryRouter/>;
    } else if (ROLE_MANAGER === roleName) {
      return <ManagerRouter/>;
    } else if (ROLE_PARTICIPANT === roleName) {
      return <ParticipantRouter/>;
    }

    return <GuestRouter/>;
  }
}
